module.exports = __webpack_public_path__ + "img/bg.1dd7b7df.jpg";